module.exports = __webpack_public_path__ + "static/media/210-Mitpatient_ID_12.defa45b9.mp3";